import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { History, Clock, User } from "lucide-react";

export default function HistoryTab({ clientId }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadHistory = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/access-center/audit", { params: { entity_type: "client", entity_id: clientId, limit: 50 } });
      setLogs(Array.isArray(data) ? data : data?.items || []);
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Erro ao carregar historico");
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => { loadHistory(); }, [loadHistory]);

  if (loading) return <Skeleton className="h-40 w-full" />;

  return (
    <div className="space-y-3">
      <Badge variant="outline">{logs.length} registro(s)</Badge>
      {logs.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-8">
          Nenhuma alteracao registrada
        </p>
      ) : (
        <div className="divide-y divide-border border border-border rounded-md">
          {logs.map((log, idx) => (
            <div key={idx} className="p-3">
              <div className="flex items-center gap-2 text-sm">
                <History className="h-4 w-4 text-muted-foreground" />
                <span className="font-medium">{log.action || log.type || "Alteracao"}</span>
              </div>
              <div className="flex items-center gap-4 mt-1 text-xs text-muted-foreground">
                <span className="flex items-center gap-1"><User className="h-3 w-3" />{log.user_name || log.user || "Sistema"}</span>
                <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{log.created_at || log.timestamp || "-"}</span>
              </div>
              {log.description && <p className="text-xs mt-1">{log.description}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
